var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1l-9 9.333V21h6.923v-5.333h4.154V21H19V10.333z",
    stroke: "#0B966B",
    strokeWidth: 1.2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconHouse;